import { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../../../config/firebase";

const useTermData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "CcpTerm"));
      const termsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by TermName alphabetically
      termsData.sort((a, b) => a.TermName.localeCompare(b.TermName));

      setData(termsData);
      setError(null);
    } catch (error) {
      console.error("Error fetching terms:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const refreshData = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "CcpTerm"));
      const termsData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by TermName alphabetically
      termsData.sort((a, b) => a.TermName.localeCompare(b.TermName));

      setData(termsData);
      setError(null);
    } catch (error) {
      console.error("Error refreshing terms:", error);
      setError(error.message);
    }
  };

  const postData = async (newData) => {
    try {
      const { TermName, StartDate, EndDate } = newData;
      await addDoc(collection(db, "CcpTerm"), {
        TermName,
        StartDate,
        EndDate,
      });

      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error adding term:", error);
      throw error;
    }
  };

  const updateData = async (updatedData) => {
    try {
      const { id, TermName, StartDate, EndDate } = updatedData;
      const termRef = doc(db, "CcpTerm", id);

      await updateDoc(termRef, {
        TermName,
        StartDate,
        EndDate,
      });

      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error updating term:", error);
      throw error;
    }
  };

  const deleteData = async (termId) => {
    try {
      await deleteDoc(doc(db, "CcpTerm", termId));
      // Refresh the list to show current data
      await refreshData();
    } catch (error) {
      console.error("Error deleting term:", error);
      throw error;
    }
  };

  return { data, loading, error, postData, updateData, deleteData };
};

export default useTermData;
